import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { loadingFalse } from "../Reducer/loaderSlice";

const Loader = () => {
    const dispatch = useDispatch();
    const isLoading = useSelector((state) => state.loading.loading);

    // 🔥 Machan, Refresh panna auto-ah loading false aahura logic inga iruku
    useEffect(() => {
        const handleBeforeUnload = () => {
            dispatch(loadingFalse());
        };
        window.addEventListener("beforeunload", handleBeforeUnload);

        // Tab refresh aagi vandha udane safe-ah oru murai false panidrom
        dispatch(loadingFalse());

        return () => window.removeEventListener("beforeunload", handleBeforeUnload);
    }, [dispatch]);

    if (!isLoading) return null;

    return (
        <div className="premium-loader-overlay">
            <div className="loader-content">
                <div className="spinner">
                    <div className="double-bounce1"></div>
                    <div className="double-bounce2"></div>
                </div>
                <p className="loader-text text-uppercase ls-2">Processing...</p>
            </div>
        </div>
    );
};

export default Loader;